import {useState} from 'react'
import {useIntl} from 'react-intl'
import {BreadCrumb} from 'src/_metronic/layout/components'
import TransactionItemList from '../component/TransactionList'
import ActivityList from '../component/ActivityList'
import Tabs from 'src/feature/bite/component/Tabs'

function TransactionListAll() {
  const intl = useIntl()
  const [currenTab, setCurrentTab] = useState('Transactions')

  const tabs = [
    {
      label: intl.formatMessage({id: 'STORE.DETAIL.OVERVIEW'}),
      key: 'Transactions',
      component: <TransactionItemList disclaimer />,
    },
    {
      label: intl.formatMessage({id: 'MENU.ACTIVITIES'}),
      key: 'Activities',
      component: <ActivityList disclaimer />,
    },
  ]

  return (
    <>
      <BreadCrumb currentPage={intl.formatMessage({id: 'MENU.TRANSACTIONS_ACTIVITIES'})} />

      <div className='card mb-5 mb-xl-10 mt-10'>
        <div className='card-body py-0 mt-4 mt-md-0'>
          <Tabs
            tabs={tabs}
            selectedTab={currenTab}
            setSelectedTab={(tab) => {
              setCurrentTab(tab)
            }}
            loading={false}
          />
        </div>
      </div>

      <div className='tab-content' id='myTabContent'>
        <div className='tab-pane fade active show' role='tabpanel'>
          <div className='card-body pt-0'>
            <div className='tab-content' id='myTabContent'>
              <div className='tab-pane fade active show' role='tabpanel'>
                <div className='card-body pt-0'>
                  {tabs.find((tab) => tab.key === currenTab)?.component}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default TransactionListAll
